import { useMutation, UseMutationResult } from 'react-query'
import request from '../request'
import { useDealership } from '../../store/zustand/dealershipStore'
import { queryClient } from '../queryClient'

type ParamsType = { account_id: number }

export const useDeleteLinkedAccount = (): UseMutationResult<
  unknown,
  unknown,
  ParamsType,
  unknown
> => {
  const dealership = useDealership()
  return useMutation(
    ({ account_id }: ParamsType) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/accounts/${account_id}`,
        method: 'DELETE',
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([dealership?.organization_id, 'linked-accounts'])
      },
    },
  )
}
